import { Box, Button, Grid, Modal, TextField, Typography, styled,FormControl,InputLabel,Select,MenuItem } from "@mui/material";
import { useState, useEffect } from "react";
import { httpRequest } from '../../../../../ui-utils/api'
import { backendHosts, apiUrl } from '../../../../../ui-utils/apiConfig'
import styles from "./UploadDocumentStyles";
import { withStyles } from "@material-ui/core/styles";
import FileOpenIcon from '@mui/icons-material/FileOpen';
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import successgif from '../../../../../ui-assets/upload_success.gif'
import errorgif from '../../../../../ui-assets/upload_error.gif'
import loadergif from '../../../../../ui-assets/upload_loader.gif'
import { PDFDocument } from 'pdf-lib';
import * as pdfjsLib from 'pdfjs-dist';  // For handling PDF decryption using pdfjs-dist
import axios  from 'axios'

pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://unpkg.com/pdfjs-dist@2.10.377/build/pdf.worker.min.js'; // For pdfjs-dist

const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 0.5,
  });

const UploadDocument = ({ classes, uploadmodal, imagesDoc, setUploadmodal, perData, picDetails, closeModal, email, phone, aadhar, docobj, setDocdata, setUser }) => { // added by dev-kartik on 02-04-25

    const [filedata,setFiledata] = useState({
        name:'',
        data:'',
        password:''
    })
    const [error, setError] = useState('')
    const [enable, setEnable] = useState(false)
    const [show, setShow] = useState(false)
    const [promise, setpromise] = useState(null)
    const [load, setLoad] = useState('')
    const [close, setClose] = useState(false)
    const [msg, setMsg] = useState('')
    const [documentType, setDocumentType] = useState("Bank_Statement") // added by dev-kartik on 02-04-25


    // useEffect(() => {// added by dev-kartik on 02-04-25
    //         (async () => {
    //             try {
    //                 const payload = {
    //                     emailid: email,
    //                     mobileno: phone,
    //                 };
    //                 if (email.length !== 0 && phone.length !== 0){
    //                     const getData = await httpRequest({
    //                         endPoint: `${backendHosts.ADMIN}${apiUrl.getUser}`,
    //                         method: "post",
    //                         instance: "instanceOne",
    //                         requestBody: payload,
    //                     });
    //                     const result = getData.data
    //                     setUser(result);
    //                 }
                    
    
    //             } catch (error) {
    //                 console.error("Error fetching client data:", error);
    //             }
    
    //         })();
    //     }, [load]);



    const select = {
        color: "#000000 ",
        width: "300px ",
        fontFamily: "cardiuma-regular ",
    };

    const intSelText = {
        color: "#000000 !important",
        fontFamily: "cardiuma-regular ! important",
        fontSize: "14px ! important",
        fontWeight: 500,
    };

    const inputColor = {
        color: "#000000 !important",
        fontFamily: "cardiuma-regular ! important",
        fontSize: "14px ! important",
        fontWeight: 500,
    };


//aadhar, pan, cheque, bankstatement
    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
    
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
    
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const convertBlobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result); 
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    };

    const handlePasswordSubmit = ()=>{
        if(filedata.password === ''){
            setError('Please Enter the Password');
        }else{
            promise?.resolve(filedata?.password)
        }
    }

    const getData = async (e) => {
        reset()
        const file = e.target.files[0]
        let fsize = (file.size / (1024 * 1024)).toFixed(2);
        const str = uploadmodal.type

        if (str !== 'fno_activation' && file.type !== "image/png" && file.type !== "image/jpeg" && file.type !== "image/gif") {
            setError('Invalid File Format (Only jpg, png, gif supported');
        }
        else if (str === 'fno_activation' && file.type !== "application/pdf") {
            setError('Invalid File Format for Bank Statement (Only pdf supported)');
        }
        else if ((str === 'aadhaar' || str === 'pan' || str === 'cancelled_cheque') && fsize > 2) {
            setError('Max 2MB allowed');
        }
        else if (str === 'fno_activation' && fsize > 20) {
            setError('Max 20MB allowed');
        }
        else {

            // const processFirstPage = async (pdfDoc) => { // dev-kartik 10-04-25
            //     try {
            //         const firstPage = await pdfDoc.getPage(1);
            //         const firstPageCanvas = document.createElement("canvas");
            //         const context = firstPageCanvas.getContext("2d");
            //         const viewport = firstPage.getViewport({ scale: 1 });

            //         firstPageCanvas.height = viewport.height;
            //         firstPageCanvas.width = viewport.width;

            //         await firstPage.render({ canvasContext: context, viewport }).promise;

            //         const base64PdfImage = firstPageCanvas.toDataURL();

            //         setFiledata((prev) => ({ ...prev, name: file.name, data: base64PdfImage }));
            //         setEnable(true)
            //         setShow(false)

            //     } catch (error) {
            //         console.error("❌ Error extracting first page:", error);
            //         setError((prevState) => ({
            //             ...prevState,
            //             msg: "Failed to extract the first page of the PDF",
            //         }));
            //     }
            // };
            if (str === 'fno_activation') { 
                // Function to convert PDF to Base64
                const bs = async () => {
                    const fileReader = new FileReader();
                    fileReader.onload = async () => {
                        const pdfBytes = new Uint8Array(fileReader.result);
                        let pdfDoc;
            
                        try {
                            const loadingTask = pdfjsLib.getDocument({ data: pdfBytes });
                            pdfDoc = await loadingTask.promise;

                            // await processFirstPage(pdfDoc);
                             // No need to continue
            
                            // const newPdfBytes = await pdfDoc.save();
                            const base64Pdf = await convertBlobToBase64(new Blob([pdfBytes], { type: 'application/pdf' }));
            
                            setFiledata((prev) => ({ ...prev, name: file.name, data: base64Pdf }));
                            setEnable(true)
                            setShow(false)
                            return;
                        } catch (error) {
                            console.log('Error loading PDF:', error);
            
                            if (error.message === "No password given") {
                                try {
                                    setError('Please enter the password for the protected PDF')
                                    setShow(true);
                                    const promise = new Promise((resolve, reject) => {
                                        setpromise({ resolve, reject });
                                    });
            
                                    const enteredPassword = await promise;
                                    console.log('Password received:', enteredPassword);
            
                                    const loadingTask = pdfjsLib.getDocument({ data: pdfBytes, password:enteredPassword });
                                    const pdfDoc = await loadingTask.promise;
            
                                    console.log("PDF decrypted successfully ");
                                    setShow(false);
                                    setError('')
                                    const base64Pdf = await convertBlobToBase64(
                                        new Blob([pdfBytes], { type: "application/pdf" })
                                    );
                                    // const base64Pdf = await convertBase64(file);
                                    setFiledata((prev) => ({ ...prev, name: file.name, data: base64Pdf }));
                                    setEnable(true)
                                } catch (decryptError) {
                                    console.error("Unable to decrypt PDF: Incorrect password or other error", decryptError);
                                    setError('Incorrect password or unable to access PDF')
                                    promise?.reject()
                                    setShow(false);
                                    setFiledata({
                                        name:'',
                                       data:'',
                                       password:''
                                   })
                                }
                            } else {
                                console.error("Error processing PDF:", error);
                                setError('Something went wrong. Please try again')
                                promise?.reject()
                                setShow(false);
                                setFiledata({
                                    name:'',
                                   data:'',
                                   password:''
                               })
                            }
                        }
                    };
                    fileReader.readAsArrayBuffer(file);
                };
                await bs();
            }            
            else{
                setEnable(true)
                const base64 = await convertBase64(file);
                setFiledata((prev)=>({...prev, name:file.name, data:base64}))
            }
        }
    }

    const updateDocStatus = (obj, key, value) => {  //Function to make the approved documents 'approved'
        if (obj.hasOwnProperty(key)) {
            obj[key] = value;
          } else {
            console.log("Key does not exist in the object.");
          }
          return obj;
    }

    const sendData = async() => {
        
        setLoad('load')
        const username = localStorage.getItem('username')
        const userId = localStorage.getItem('user_id1')

        const document_status = updateDocStatus(docobj, uploadmodal?.type, true)
        //Creating the payload
     
        
        let payload = {
            data: {
                email: perData.email,
                mobile: perData.mobile,
                id: perData.user_id,
                type: uploadmodal?.type,
                base64: filedata.data
            }
        };

        if (uploadmodal?.type === "fno_activation"){
                 payload.data['fno_type']=documentType;
                payload.data['password'] = filedata.password || ""  
             }


      

        // const fileTypeMap = {
        //     aadhaar: 'aadharData',
        //     pan: 'panData',
        //     cheque: 'chequeData',
        //     bankstatement: 'bankStatmentData',
        //   };

        // const fileDataKey = fileTypeMap[uploadmodal?.type];
        // if (fileDataKey) {
        //     payload.data['base64'] = filedata.data;
        //     // payload['verification'] = 'CRM upload -' + uploadmodal?.type === "bankstatement" ? documentType : uploadmodal?.type
        // }

        console.log("uploadpayload", payload)
       

        const UploadResponse = await axios.post(`${backendHosts.ADMIN}${apiUrl.uploadDocument}`, payload)
        if (UploadResponse.data.data.status === 200 && UploadResponse.data.data.data.success){
            imagesDoc()
            
            setFiledata({
                name:'',
               data:'',
               password:''
           })
            setLoad('success')
            setMsg('File Uploaded Successfully')   
        }else{
            setFiledata({
                name:'',
               data:'',
               password:''
           })
            setLoad('error')
            setMsg('Something went wrong. Please try again')
        }
        setEnable(false)
        setClose(true)
    }

    const reset = () => {
        setFiledata({
             name:'',
            data:'',
            password:''
        })
        setError('')
        setEnable(false)
        setLoad('')
    }
  
  return (
    <>
      <Modal open={uploadmodal?.open}>
        <Box className={classes.modal}>
            <Typography className={classes.uploadText}  >
                Upload {uploadmodal?.type} File
            </Typography>
            <Grid className={classes.uploadGrid}>
                <Box className={classes.uploadBox}>

                    {
                              // added by dev-kartik on 02-04-25
                              uploadmodal?.type === "fno_activation" && load === "" &&
                              <FormControl
                                  size="small"
                                  sx={{
                                      marginTop: "40px !important",
                                      width: "70% !important",
                                  }}
                              >
                                  <InputLabel
                                      sx={inputColor}
                                      id="demo-select-small-label"
                                      shrink={true}
                                  >
                                      Document Type
                                  </InputLabel>

                                  <Select
                                      sx={select}
                                      labelId="demo-select-small-label"
                                      id="demo-select-small"
                                      value={documentType}
                                      label="Document Type"
                                      onChange={(e) => setDocumentType(e.target.value)}
                                      displayEmpty
                                      MenuProps={{
                                          getContentAnchorEl: null,
                                          anchorOrigin: {
                                              vertical: "bottom",
                                              horizontal: "left",
                                          },
                                          PaperProps: {
                                              style: {
                                                  maxHeight: 200,
                                                  top: "0px",
                                              },
                                          },
                                      }}
                                  >
                                      <MenuItem sx={intSelText} value="Bank_Statement">
                                          Latest Bank Statement of Last 6 Months
                                      </MenuItem>
                                      <MenuItem sx={intSelText} value="Salary_Slip">
                                          Salary Slip (Last Month)
                                      </MenuItem>
                                      <MenuItem sx={intSelText} value="ITR">
                                          IT Return (Last Year)
                                      </MenuItem>
                                      <MenuItem sx={intSelText} value="Net_Worth">
                                          Net Worth Certificate
                                      </MenuItem>
                                      <MenuItem sx={intSelText} value="Demat_Statement">
                                          Demat Account Holding Statement
                                      </MenuItem>
                                      <MenuItem sx={intSelText} value="Form_16">
                                          Copy of last Form 16
                                      </MenuItem>
                                  </Select>
                              </FormControl>
                    }

                {load === '' ? <Button
                        component="label"
                        className={classes.chooseButton}
                        variant="contained"
                        tabIndex={-1}
                        startIcon={<FileOpenIcon />}
                    >
                        Choose file
                        <VisuallyHiddenInput
                        type="file"
                        onChange={(e) => {
                            getData(e);
                        }}
                        ref={(input) => {
                            if (input) {
                            input.value = null;
                            }
                        }}
                        />
                    </Button> :
                    <img src={load === 'load'? loadergif :(load === 'success'?  successgif : (load === 'error'?  errorgif : loadergif))} style={{height:'120px'}}></img>} 
                </Box>
                <Box className={classes.uploadedText}>
                    {error !== '' && <Typography className={classes.errText} sx={{textAlign:'center !important'}}>{error}</Typography>}
                    {msg !== '' && <Typography className={classes.filename} sx={{textAlign:'center !important'}}>{msg}</Typography>}
                    {filedata.name !=='' && <Typography className={classes.filename}><span style={{color:'#747474'}}>File name</span> : {filedata.name}</Typography>}
                </Box>
                {show &&
                    <Grid mb={2} sx={{width:'100%',display:'flex !important'}}> 
                        <TextField sx={{width:'80%'}} size="small" type='password' label="Password" variant="outlined" onChange={(event)=>{setFiledata((prev)=>({...prev, password:event.target.value}))}}/>
                        <Button sx={{marginLeft:'15px'}} onClick={()=>handlePasswordSubmit()} className={classes.button}>Submit</Button>
                    </Grid>}
                <Grid sx={{display:'flex', justifyContent:'end'}}>
                    <Button onClick={closeModal} className={classes.button} >{close? 'OK':'CANCEL'}</Button>
                    {!close && <Button sx={{marginLeft:'15px'}} onClick={()=>sendData()} className={enable ? classes.button : classes.disabledButton}  disabled={!enable}>{load ==='' ? 'SUBMIT':'OK'}</Button>}
                </Grid>
            </Grid >
        </Box>
      </Modal>
    </>
  );
};

export default withStyles(styles)(UploadDocument);
